// extracted by mini-css-extract-plugin
export default {"Chart":"OTpGS","Detail":"VJv3b","Value":"bh1A1","Title":"wQNxz","Donut":"y376R"};